import { NotificationContext } from "context/NotificationContext";
import { useContext } from "react";
import Alert from "./Alert";

const AlertContainer = () => {
  const { notification, isOpen, dismissNotification } =
    useContext(NotificationContext);
  return (
    notification && (
      <Alert
        isOpen={isOpen}
        onClose={dismissNotification}
        title={notification.title}
        message={notification.message}
        type={notification.type}
      />
    )
  );
};

export default AlertContainer;
